/* Accumulatore che tiene traccia del numero totale di risultati
N
*/
import { createContext } from "react";
const NOfResultsContext = createContext({
    nOfResults: 0,
    setNOfResults: (n) => {}
  });
export default NOfResultsContext;